import "core-js/modules/es.array.map";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.replace";

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Nick Cattaneo; Thomas Barry

 Description:
 */
import box from '../box/box';
import { DOLLAR_SIGN_WHOLE, DOLLAR_SIGN_DECIMAL, DOLLAR_WHOLE, DOLLAR_DECIMAL, PERCENTAGE, PERCENTAGE_DECIMAL, SSN_LAST_4_DIGIT } from '../types/format-types';
import { ALPHA, ALPHA_NUMERIC, ALPHA_NUMERIC_SPACE, ALPHA_NUMERIC_SPECIAL, EMAIL, ALPHA_SPACE, ALPHA_SPECIAL, DATE, NUMERIC, NUMERIC_DECIMAL, NUMERIC_SPECIAL } from '../types/data-types';

var convertToString = function convertToString(value) {
  return value === null || typeof value === 'undefined' ? '' : value.toString();
}; // TODO => need to split out the Masking from AddFormatting


export var addFormatting = function addFormatting(type, value) {
  var $value = convertToString(value);

  switch (type) {
    case DOLLAR_DECIMAL:
      return box($value).map(function (value) {
        return value.replace(/[^\d]/g, '');
      }).map(function (cleaned) {
        return Number(cleaned) / 100;
      }).fold(function (amount) {
        return amount.toFixed(2);
      });

    case DOLLAR_SIGN_WHOLE:
      return '$' + $value.replace(/[^\d]/g, '').replace(/^00+/g, '0').replace(/(\d)(?=(?:.{3})+$)/g, '$&,');

    case DOLLAR_SIGN_DECIMAL:
      return '$' + $value.replace(/(\d)(?=(\d{3})+\.)/g, '$1,');

    case DOLLAR_WHOLE:
      return $value.replace(/[^\d]/g, '').replace(/^00+/g, '0').replace(/(\d)(?=(?:.{3})+$)/g, '$&,');

    case PERCENTAGE:
      return $value.replace(/[^\d]/g, '') + '%';

    case PERCENTAGE_DECIMAL:
      return $value.replace(/[^\d.]/g, '') + '%';

    case ALPHA:
      return $value.replace(/[^a-zA-Z\s]/g, '');

    case ALPHA_NUMERIC:
    case ALPHA_NUMERIC_SPACE:
      return $value.replace(/[^a-zA-Z\d\s]/g, '');

    case ALPHA_NUMERIC_SPECIAL:
      return $value.replace(/[^a-zA-Z\d\s~!@#$%^&*()_;=\\'"+-]/g, '');

    case ALPHA_SPACE:
      return $value.replace(/[^a-zA-Z\s]/g, '');

    case ALPHA_SPECIAL:
      return $value.replace(/[^a-zA-Z\s~!@#$%^&*()_;=\\'"+-]/g, '');

    case DATE:
    case NUMERIC:
    case SSN_LAST_4_DIGIT:
      return $value.replace(/[^\d]/g, '');

    case EMAIL:
      return $value.replace(/[^a-zA-Z\d@.~!@#$%^&*()_;=\\'"+-]/g, '');

    case NUMERIC_DECIMAL:
      return $value.replace(/[^\d.]/g, '');

    case NUMERIC_SPECIAL:
      return $value.replace(/[^\d~!@#$%^&*()_;=\\'"+-]/g, '');

    default:
      return $value;
  }
};
export var removeFormatting = function removeFormatting(type, value) {
  var $value = convertToString(value);

  switch (type) {
    case ALPHA:
    case ALPHA_SPACE:
      return $value.replace(/[^a-zA-Z\s]/g, '');

    case ALPHA_NUMERIC:
    case ALPHA_NUMERIC_SPACE:
      return $value.replace(/[^a-zA-Z\d\s]/g, '');

    case ALPHA_NUMERIC_SPECIAL:
      return $value.replace(/[^a-zA-Z\d\s~!@#$%^&*()_;=\\'"+-]/g, '');

    case ALPHA_SPECIAL:
      return $value.replace(/[^a-zA-Z\s~!@#$%^&*()_;=\\'"+-]/g, '');

    case DOLLAR_WHOLE:
    case DOLLAR_SIGN_WHOLE:
      return $value.replace(/[^\d]/g, '').length > 0 ? Number($value.replace(/[^\d]/g, '')).toString() : '';
    // by converting it to a number then to a string, leading 0's are removed

    case DATE:
    case NUMERIC:
    case PERCENTAGE:
    case SSN_LAST_4_DIGIT:
      return $value.replace(/[^\d]/g, '');

    case EMAIL:
      return $value.replace(/[^a-zA-Z\d.~!@#$%^&*()_;=\\'"+-]/g, '');

    case DOLLAR_SIGN_DECIMAL:
    case NUMERIC_DECIMAL:
      return $value.replace(/[^\d.]/g, '');

    case NUMERIC_SPECIAL:
      return $value.replace(/[^\d~!@#$%^&*()_;=\\'"+-]/g, '');

    default:
      return $value;
  }
};